(function () {
	function isVisibleEl(el) {
		if (!el) return false;
		if (el.hidden || el.getAttribute("aria-hidden") === "true") return false;
		if (el.closest("[hidden]")) return false;
		return true;
	}

	function readPerRowValue(btn) {
		if (!btn) return "";
		return btn.getAttribute("data-per-row") || btn.dataset.perRow || "";
	}

	function isClistCollectionsListScope(scope) {
		if (!scope) return false;
		return scope.querySelector("[data-clist-products-inner]") != null;
	}

	function isClistDualGridScope(scope) {
		if (!scope) return false;
		return (
			scope.querySelector("[data-clist-collections-grid]") != null &&
			scope.querySelector("#ProductGridContainer") != null
		);
	}

	function getPerRowTargets(scope) {
		if (!scope) return [];

		if (isClistCollectionsListScope(scope) || isClistDualGridScope(scope)) {
			const targets = [];
			const collectionsGrid =
				scope.querySelector("#CollectionListGridContainer") ||
				scope.querySelector("[data-clist-collections-grid]");
			const productsGrid =
				scope.querySelector("[data-clist-products-inner] #ProductGridContainer") ||
				scope.querySelector("#ProductGridContainer");
			if (collectionsGrid) targets.push(collectionsGrid);
			if (productsGrid && productsGrid !== collectionsGrid) targets.push(productsGrid);
			if (targets.length) return targets;
		}

		const productGrid = scope.querySelector("#ProductGridContainer");
		if (productGrid && isVisibleEl(productGrid)) return [productGrid];

		const collectionsGrid = scope.querySelector("#CollectionListGridContainer");
		if (collectionsGrid && isVisibleEl(collectionsGrid)) return [collectionsGrid];

		const inner = scope.querySelector("[data-clist-products-inner] #ProductGridContainer");
		if (inner) return [inner];

		return [...scope.querySelectorAll("[data-productis-in-row]")].filter(isVisibleEl);
	}

	function getScopeFromButton(btn) {
		return btn.closest('[id^="shopify-section-"]') || document;
	}

	function getMaxPerRowForSection(sectionEl) {
		if (!sectionEl) return 4;
		const raw = getComputedStyle(sectionEl).getPropertyValue("--per-row").trim();
		const parsed = parseInt(raw, 10);
		return Number.isNaN(parsed) || parsed < 1 ? 4 : Math.min(parsed, 4);
	}

	function columnsForMode(mode, maxPerRow) {
		if (mode === "small") {
			if (maxPerRow <= 1) return 1;
			if (maxPerRow === 2) return 2;
			return Math.min(3, maxPerRow);
		}
		return maxPerRow;
	}

	function applyCollectionListWrapperClass(container, mode) {
		if (
			!container ||
			(container.id !== "CollectionListGridContainer" &&
				!container.hasAttribute("data-clist-collections-grid"))
		) {
			return;
		}
		const grid = container.querySelector("[id^='CollectionListGrid-']");
		if (!grid) return;

		const sectionEl = container.closest("[id^='shopify-section-']");
		const cols = columnsForMode(mode, getMaxPerRowForSection(sectionEl));

		grid.classList.remove(
			"wrapper-per-row__1",
			"wrapper-per-row__2",
			"wrapper-per-row__3",
			"wrapper-per-row__4"
		);
		grid.classList.add(`wrapper-per-row__${cols}`);
	}

	function getProductsGridContainer(scope) {
		return (
			scope.querySelector("[data-clist-products-inner] #ProductGridContainer") ||
			scope.querySelector("#ProductGridContainer")
		);
	}

	function getActivePerRowValue(scope) {
		if (isProductsToolbarScope(scope)) {
			const fromContainer = getProductsGridContainer(scope)?.getAttribute("data-productis-in-row");
			if (fromContainer) return fromContainer;
		}

		const active = scope.querySelector(
			'[data-clist-toolbar-per-row] .per-row__button.active, .per-row__wrapper .per-row__button.active'
		);
		return readPerRowValue(active) || "large";
	}

	function setActivePerRowButtons(scope, value) {
		if (!value) return;
		scope.querySelectorAll(".per-row__wrapper").forEach((wrap) => {
			wrap.querySelectorAll(".per-row__button").forEach((btn) => {
				btn.classList.toggle("active", readPerRowValue(btn) === value);
			});
		});
	}

	function isProductsToolbarScope(scope) {
		if (!scope) return false;
		if (scope.classList.contains("clist-view-products-active")) return true;
		const panel = scope.querySelector("#view-products-content");
		return Boolean(panel && !panel.hidden);
	}

	function applyPerRowValue(scope, value) {
		if (!value || !scope) return;

		getPerRowTargets(scope).forEach((target) => {
			target.setAttribute("data-productis-in-row", value);
			applyCollectionListWrapperClass(target, value);
		});

		window.ClistMobileGridBorders?.scheduleUpdate?.(scope);
	}

	function handlePerRowClick(btn) {
		const value = readPerRowValue(btn);
		if (!value) return;

		const scope = getScopeFromButton(btn);
		setActivePerRowButtons(scope, value);
		applyPerRowValue(scope, value);
	}

	let delegated = false;

	function bindDelegatedClick() {
		if (delegated) return;
		delegated = true;

		document.addEventListener("click", function (event) {
			const btn = event.target.closest(".per-row__button");
			if (!btn) return;
			handlePerRowClick(btn);
		});
	}

	function syncClistListSection(scope) {
		if (!scope) return;
		applyPerRowValue(scope, getActivePerRowValue(scope));
	}

	function syncAllClistListSections() {
		document.querySelectorAll('[id^="shopify-section-"]').forEach((section) => {
			if (isClistCollectionsListScope(section) || isClistDualGridScope(section)) {
				syncClistListSection(section);
			}
		});
	}

	function boot() {
		bindDelegatedClick();
		syncAllClistListSections();
	}

	document.addEventListener("shopify:section:load", boot);
	document.addEventListener("clist:products-injected", syncAllClistListSections);
	document.addEventListener("clist:products-view-ready", syncAllClistListSections);

	window.ClistPerRow = {
		applyPerRowValue,
		getPerRowTargets: function ($scopeOrEl) {
			const scope =
				$scopeOrEl && $scopeOrEl.jquery ? $scopeOrEl.get(0) : $scopeOrEl;
			return getPerRowTargets(scope || document);
		},
		getActivePerRowValue,
		setActivePerRowButtons,
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot);
	} else {
		boot();
	}

	(function initVariantCardDebug() {
		const RUN_ID = "pre-fix-variant-card-followups";
		let pending = 0;

		function readTitle(card) {
			return (card.querySelector(".card__title a")?.textContent || "").trim();
		}

		function readHref(card) {
			return card.querySelector(".card__title a")?.getAttribute("href") ||
				card.querySelector(".media")?.getAttribute("href") ||
				"";
		}

		function visibleCards() {
			return Array.from(document.querySelectorAll("#ProductGridContainer #product-grid.collection-product-list > li.collection-grid-card")).filter((card) => {
				if (card.hidden) return false;
				const style = window.getComputedStyle(card);
				if (style.display === "none" || style.visibility === "hidden") return false;
				const rect = card.getBoundingClientRect();
				return rect.width > 0 && rect.height > 0;
			});
		}

		function logVariantCards(reason) {
			const container = document.querySelector("#ProductGridContainer");
			if (!container) return;
			const cards = visibleCards();
			const sample = cards.slice(0, 24).map((card) => ({
				productHandle: card.getAttribute("data-product-handle") || "",
				variantId: card.getAttribute("data-variant-id") || "",
				renderedTitle: readTitle(card),
				href: readHref(card),
				productCategory: card.getAttribute("data-agent-product-category") || "",
				variantCategory: card.getAttribute("data-agent-variant-category") || "",
				productColor: card.getAttribute("data-agent-product-color") || "",
				variantColor: card.getAttribute("data-agent-variant-color") || "",
				variantTitle: card.getAttribute("data-agent-variant-title") || "",
				variantOptions: card.getAttribute("data-agent-variant-options") || "",
				productFilters: card.getAttribute("data-product-filters") || "",
				productVariantText: card.getAttribute("data-product-variant-text") || "",
			}));
			// #region agent log
			fetch('http://127.0.0.1:7368/ingest/1a86f5ac-d0df-4f93-8db4-f7982947bf27',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'4d213f'},body:JSON.stringify({sessionId:'4d213f',runId:RUN_ID,hypothesisId:'H1,H2,H3,H4',location:'assets/products-per-row.js:variant-card-debug',message:'Variant card data model snapshot',data:{reason,path:window.location.pathname,search:window.location.search,mode:container.getAttribute("data-productis-in-row") || "",visibleCount:cards.length,sample},timestamp:Date.now()})}).catch(()=>{});
			// #endregion
		}

		function scheduleVariantCardDebug(reason) {
			if (pending) cancelAnimationFrame(pending);
			pending = requestAnimationFrame(() => {
				pending = 0;
				logVariantCards(reason);
			});
		}

		document.addEventListener("DOMContentLoaded", () => scheduleVariantCardDebug("domcontentloaded"));
		document.addEventListener("change", (event) => {
			if (event.target.closest("facet-filters-form, .facets-sorting, [data-clist-products-sort]")) {
				scheduleVariantCardDebug("filter-or-sort-change");
			}
		});
		document.addEventListener("click", (event) => {
			if (event.target.closest(".per-row__button, [data-clist-view], .js-load-more")) {
				scheduleVariantCardDebug("grid-control-click");
			}
		}, true);
		document.addEventListener("clist:products-injected", () => scheduleVariantCardDebug("products-injected"));
		document.addEventListener("clist:products-view-ready", () => scheduleVariantCardDebug("products-view-ready"));
		scheduleVariantCardDebug("init");
	})();
})();
